import styled from 'styled-components';

import { WithIsHome, WithTeam } from '~/core/styleTypes';
import { getEntityBackgroundColor, getEntityTextAndBorderColor } from '~/views/pages/gameCenter/utils';

export const EventIcon = styled.svg<WithTeam & WithIsHome>`
    circle {
        stroke-width: 1;
        stroke: ${({ theme, $isHome, $teamAbbrev }) => getEntityTextAndBorderColor(theme, $isHome, $teamAbbrev)};
        fill: ${({ theme, $isHome, $teamAbbrev }) => getEntityBackgroundColor(theme, $isHome, $teamAbbrev)};
    }

    svg {
        fill: ${({ theme, $isHome, $teamAbbrev }) => getEntityTextAndBorderColor(theme, $isHome, $teamAbbrev)};
    }
`;
